import React, { useState, useRef, useEffect } from 'react';

import RadioButton from "../../../../../ui/RadioButton";
import Button from "../../../../../ui/Button";
import DropDown from "../../../../../ui/DropDown";

import { filterIcon } from "../../../../../../utils/icons";
import { getloggedInUserType } from "../../../../../../utils/util";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const statusOption = [    
    {
        label: "Open",
        value: "open"
    },
    {
        label: "Closed",
        value: "closed"
    },
    {
        label: "Won't Fix",
        value: "Wont_fix"
    }
]

const SeverityOption = [
    {
        label: "Critical",
        value: "critical"
    },
    {
        label: "High",
        value: "high"
    },
    {
        label: "Medium",
        value: "medium"
    },
    {
        label: "Low",
        value: "low"
    },
    {
        label: "Informational",
        value: "informational"
    },
    {
        label: "Unknown",
        value: "unknown"
    },
]

const falsePositiveOption = [
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const riskOption = [  
    {
        label: "Potential",
        value: "potential"
    },
    {
        label: "Confirmed",
        value: "confirmed"
    },
]

const verifiedOption = [
    {
        label: "POC",
        value: "poc"
    },
    {
        label: "Version",
        value: "version"
    }
]

const emailStatusOption = [
    {
        label: "Active",
        value: "active"
    },
    {
        label: "Inactive",
        value: "inactive"
    },
    {
        label: "All",
        value: "all"
    }
]


const EndpointsFilter = ({endPointFilterApply, endpointFiltersValue, currentPage="default"}) => {

    const endpointFilterWrapperRef = useRef(null);

    // list filter
    const [showFilter, setShowFilter] = useState(false);
    const [listNewFindings, setListNewFindings] = useState("");
    const [listStatusSelected, setListStatusSelected] = useState("");
    const [listSeveritySelected, setListSeveritySelected] = useState("");
    const [listRiskSelected, setListRiskSelected] = useState("");
    const [listFalsePositiveSelected, setListFalsePositiveSelected] = useState("");
    const [listVerfiedBy, setListVerifiedBy] = useState("");
    const [listEmailStatus, setListEmailStatus] = useState(""); 

    const applyFilter = () => {
        let obj = {
            newFindings: listNewFindings ? newFindingsOption.find((data) => data.value === listNewFindings) : {},
            status: listStatusSelected ? statusOption.find((data) => data?.value === listStatusSelected) : {},
            severity: listSeveritySelected ? SeverityOption.find((data) => data?.value === listSeveritySelected) : {},
            risk: listRiskSelected ? riskOption.find((data) => data.value === listRiskSelected) : {},
            falsePositive: listFalsePositiveSelected ? falsePositiveOption.find((data) => data?.value === listFalsePositiveSelected) : {},
            verifiedBy: listVerfiedBy ? verifiedOption.find((data) => data?.value === listVerfiedBy) : {},
            emailStatus: listEmailStatus ? emailStatusOption.find((data) => data.value === listEmailStatus) : {}
        }
        endPointFilterApply(obj)
        setShowFilter(false);
    }

    useEffect(()=>{
        setListNewFindings(endpointFiltersValue?.newFindings?.value || "")
        setListStatusSelected(endpointFiltersValue?.status?.value || "")
        setListSeveritySelected(endpointFiltersValue?.severity?.value || "")
        setListRiskSelected(endpointFiltersValue?.risk?.value || "")
        setListFalsePositiveSelected(endpointFiltersValue?.falsePositive?.value || "")
        setListVerifiedBy(endpointFiltersValue?.verifiedBy?.value || "")
        setListEmailStatus(endpointFiltersValue?.emailStatus?.value || "")
    },[endpointFiltersValue])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (endpointFilterWrapperRef.current && !endpointFilterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }        
        }
    },[showFilter])

    return (
        <>
            <div className="position-relative">
                <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>
                {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={endpointFilterWrapperRef}>
                    <h6>New Findings</h6>
                    <div className="filter-user-status d-flex mb-3 gap-4">
                        {
                            newFindingsOption.map((data,index)=>{
                                return (
                                    <RadioButton radioId={`endpoints-${data.label}-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setListNewFindings(value)}} key={index} isChecked={data.value === listNewFindings} />
                                )
                            })
                        }
                    </div>
                    { getloggedInUserType() === "internal" && currentPage !== "leakedCredentials" &&  currentPage !== "botnetLeaks" && currentPage !== "criticalVulnerabilities" && 
                        <>
                            <h6>False Positive</h6>
                            <div className="filter-user-status d-flex mb-3 gap-4">
                                {
                                    falsePositiveOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={`endpoints-false-${data.label}-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setListFalsePositiveSelected(value)}} key={index} isChecked={data.value === listFalsePositiveSelected} />
                                        )
                                    })
                                }
                            </div>
                        </>
                    }
                    { currentPage !== "leakedCredentials" && currentPage !== "botnetLeaks" &&
                        <>
                            <h6>Status</h6>
                            <div className="filter-user-status d-flex mb-3 gap-4">
                                {
                                    statusOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={`endpoints-${data.label}-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setListStatusSelected(value)}} key={index} isChecked={data.value === listStatusSelected} />
                                        )
                                    })
                                }
                            </div>
                        </>
                    }
                    {
                        currentPage === "cves" &&
                        <>
                            <h6>Verified By</h6>
                            <div className="filter-user-status d-flex mb-3 gap-4">
                                {
                                    verifiedOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={`endpoints-${data.label}-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setListVerifiedBy(value)}} key={index} isChecked={data.value === listVerfiedBy} />
                                        )
                                    })
                                }
                            </div>
                        </>
                    }
                    {   currentPage !== "subdomainTakeover" && currentPage !== "leakedCredentials" && currentPage !== "botnetLeaks" && currentPage !== "cves" &&
                        <>
                            <h6>Severity</h6>
                            <DropDown 
                                placeHolder={"Severity"}
                                options={SeverityOption}
                                isMulti={false}
                                isSearchable={false}
                                onChange={(data)=>{setListSeveritySelected(data.value)}}
                                defaultSelectedValue={listSeveritySelected}
                            />
                        </>
                    }
                    {
                        currentPage === "subdomainTakeover" &&
                        <>
                            <h6>Risk</h6>
                            <div className="filter-user-status d-flex mb-3 gap-4">
                                {
                                    riskOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={`endpoints-${data.label}-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setListRiskSelected(value)}} key={index} isChecked={data.value === listRiskSelected} />
                                        )
                                    })
                                }
                            </div>
                        </>
                    }
                    {
                        currentPage === "leakedCredentials" &&
                        <>
                            <h6>Email Status</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    emailStatusOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={`endpoints-Email-${data.label}-${index}`} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setListEmailStatus(value)}} key={index} isChecked={data.value === listEmailStatus} />
                                        )
                                    })
                                }
                            </div>
                        </>
                    }                   
                    <div className="filter-apply-btn mt-3">
                        <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={false} buttonClicked={()=>{applyFilter()}}/>
                    </div>
                </div>}
            </div>
        </>
    )
}

export default EndpointsFilter;